const Languages = {
  title: "Langues",
  courses: [
    {
      title: "CACES - Conduite d'engins de chantier",
      objectives: [
        "Comprendre les règles de sécurité et les obligations liées à l'utilisation des engins de chantier",
        "Être capable de conduire des engins de chantier en toute sécurité",
        "Maîtriser les gestes techniques de conduite d’engins spécifiques",
        "Être apte à manipuler différents types d’engins de chantier (chariots élévateurs, grues, etc.)",
        "Passer l'examen pour obtenir le certificat CACES",
      ],
      content: [
        "Règles de sécurité sur les chantiers",
        "Types d'engins de chantier et leur utilisation",
        "Conduite d'engins : Chariots élévateurs, grues, pelleteuses",
        "Gestion de la circulation sur site",
        "Manipulation des charges et équipements de levage",
        "Entretien et vérification des engins",
        "Précautions à prendre en cas de conditions météorologiques difficiles",
        "Signalisation sur chantier",
        "Test pratique de conduite d'engins",
        "Examen théorique et pratique pour l'obtention du CACES",
      ],
      duration: "Durée a determiner selon le besoin.",
      // duration: "20h environ (8h théorie + 12h pratique)",
      prerequisites:
        "Être en bonne condition physique et ne pas avoir de contre-indication médicale",
      accessibility:
        "Formations en présentiel avec des équipements adaptés aux personnes à mobilité réduite",
      materials: [
        "Une tenue de travail adaptée",
        "Casque, gants, et autres équipements de sécurité",
        "Un engin de chantier adapté à la formation",
      ],
      evaluation: [
        "Examen théorique sous forme de QCM",
        "Évaluation pratique de conduite d'engins",
        "Évaluation de la maîtrise des règles de sécurité sur chantier",
      ],
      methods: [
        "Cours théoriques en salle et démonstrations vidéo",
        "Séances pratiques sur chantier avec différents types d'engins",
        "Simulation d'incidents et gestion de situations d'urgence",
        "Encadrement par des formateurs expérimentés",
      ],
      trainer:
        "Formateurs certifiés CACES, experts en conduite d'engins et sécurité sur site.",
    },
    {
      title: "Commerce avec la Chine",
      objectives: [
        "Comprendre les enjeux et spécificités du marché chinois",
        "Savoir négocier et communiquer efficacement avec des partenaires chinois",
        "Maîtriser les différences culturelles et leurs impacts dans les affaires",
        "Apprendre les stratégies de développement commercial en Chine",
        "Acquérir des compétences pour gérer des transactions commerciales internationales",
      ],
      content: [
        "Introduction au marché chinois et son environnement économique",
        "Les secteurs porteurs en Chine",
        "Les spécificités culturelles et leur influence sur les affaires",
        "Le protocole et les codes de la négociation en Chine",
        "Les stratégies marketing adaptées au marché chinois",
        "Les formalités administratives et juridiques pour faire des affaires en Chine",
        "La gestion des partenariats et des relations commerciales",
        "Les modes de financement et les méthodes de paiement en Chine",
        "Les risques et les opportunités dans le commerce avec la Chine",
        "Étude de cas pratiques sur les entreprises ayant réussi en Chine",
      ],
      duration: "Durée a determiner selon le besoin.",
      prerequisites:
        "Avoir des connaissances de base en commerce international ou en gestion d'entreprise",
      accessibility:
        "Formations accessibles en distanciel, adaptées aux personnes à mobilité réduite",
      materials: [
        "Un ordinateur ou une tablette pour accéder aux cours en ligne",
        "Documents de référence et études de cas",
        "Accès à des ressources en ligne et des forums de discussion",
      ],
      evaluation: [
        "Examen théorique sous forme de QCM sur les concepts clés",
        "Études de cas pratiques pour évaluer la compréhension des stratégies commerciales",
        "Évaluation des compétences de négociation en groupe",
      ],
      methods: [
        "Cours théoriques en ligne et en présentiel",
        "Ateliers pratiques sur les techniques de négociation et de gestion de partenariats",
        "Webinaires avec des experts du commerce international",
        "Assistance par téléphone et/ou email pour les questions spécifiques",
      ],
      trainer:
        "Formateurs spécialisés en commerce international avec expérience du marché chinois.",
    },
    {
      title: "Coiffure et Esthétique",
      objectives: [
        "Apprendre les techniques fondamentales de coupe, coiffage et coloration",
        "Maîtriser les soins esthétiques du visage, du corps et des ongles",
        "Comprendre les aspects liés à l'hygiène et la sécurité dans les salons de coiffure et d'esthétique",
        "Développer des compétences en conseil et en relation client",
        "Être capable de réaliser des prestations esthétiques de qualité dans un cadre professionnel",
      ],
      content: [
        "Techniques de coupe et de coiffage (hommes, femmes, enfants)",
        "Coloration et décoloration des cheveux : techniques et produits",
        "Soins du visage : nettoyage, hydratation, traitements anti-âge",
        "Soins du corps : épilation, massages, soins relaxants",
        "Manucure et pédicure : techniques de base et soins des ongles",
        "Hygiène et sécurité dans le salon de coiffure et d'esthétique",
        "Relation client et communication dans un environnement de beauté",
        "Conseils en coiffure et esthétique : personnalisation des prestations",
        "Tendances et innovations dans le domaine de la coiffure et de l'esthétique",
        "Création de looks professionnels : coiffures de soirée, maquillage",
      ],
      duration: "Durée a determiner selon le besoin.",
      prerequisites:
        "Aucun prérequis, mais une passion pour l'univers de la beauté est conseillée",
      accessibility:
        "Formations en présentiel accessibles aux personnes à mobilité réduite, équipements adaptés",
      materials: [
        "Un kit de coiffure et esthétique (ciseaux, peignes, brosses, sèche-cheveux, etc.)",
        "Produits cosmétiques pour les soins du visage et du corps",
        "Un espace pratique équipé de stations de coiffure et d'esthétique",
      ],
      evaluation: [
        "Examen pratique de coiffure et de soins esthétiques",
        "Évaluation théorique sur les produits, techniques et hygiène",
        "Évaluation de la relation client et des compétences en conseil",
      ],
      methods: [
        "Cours théoriques en ligne et en présentiel avec démonstrations",
        "Ateliers pratiques pour maîtriser les techniques de coiffure et de soins",
        "Sessions de mise en situation avec des clients pour pratiquer la relation client",
        "Assistance personnalisée et conseils des formateurs expérimentés",
      ],
      trainer: "Formateurs experts en coiffure et esthétique",
    },
    {
      title: "Infographie - Photoshop CC2023",
      objectives: [
        "Maîtriser l'interface de Photoshop",
        "Manipuler les outils de base de Photoshop",
        "Comprendre les concepts colorimétriques et de résolution",
        "Maîtriser les fonctionnalités avancées de Photoshop",
        "Utiliser les fonctionnalités spécialisées de Photoshop",
      ],
      content: [
        "Espace de travail dans Photoshop",
        "Modes colorimétriques",
        "Résolution des images",
        "Recadrage et transformations",
        "Sélections et outils de sélection",
        "Utilisation des calques et des groupes",
        "Colorimétrie et gestion des couleurs",
        "Historique et retouche d'images",
        "Effets spéciaux et filtres",
        "Utilisation des outils vectoriels",
        "Dégradés et modes de fusion",
        "Utilisation du texte et styles de calque",
        "Exportation et sauvegarde des images",
        "Masques de fusion et calques de réglages",
        "Objets dynamiques et 3D dans Photoshop",
        "Utilisation des scripts et animation vidéo",
      ],
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis, accessible à tous publics",
      accessibility:
        "Formation accessible en distanciel, sans audio description ni sous-titrage, accessible aux personnes à mobilité réduite",
      materials: [
        "Un ordinateur ou une tablette avec Adobe Photoshop CC2023 installé",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Formation accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email pour les questions techniques et pédagogiques",
      ],
      trainer: "Formateur expérimenté en infographie et Photoshop.        ",
    },

    {
      title: "Sauveteur Secouriste du Travail (SST)",
      objectives: [
        "Acquérir les compétences nécessaires pour porter secours en cas d'accident au travail",
        "Apprendre à prévenir les risques professionnels et adopter une attitude proactive en matière de sécurité",
        "Savoir alerter les secours et appliquer les gestes de premiers secours",
        "Intervenir efficacement face à une situation d’accident ou de malaise",
        "Comprendre le rôle du SST dans l'organisation de la prévention en entreprise",
      ],
      content: [
        "Le cadre juridique du SST et la prévention des risques professionnels",
        "Identification des situations dangereuses en milieu professionnel",
        "Les principes de base des premiers secours",
        "Protection et sécurisation de la zone d’accident",
        "Examen de la victime et alerte des secours",
        "Gestes de secours : arrêt des hémorragies, massage cardiaque, utilisation du défibrillateur",
        "Cas pratiques et mises en situation",
        "Évaluation des compétences et certification",
      ],
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis nécessaire",
      accessibility:
        "Formation accessible aux personnes en situation de handicap avec aménagements possibles",
      materials: [
        "Manuel du SST",
        "Matériel de secourisme (pansements, mannequins de réanimation, défibrillateurs d’entraînement)",
        "Vidéos et supports pédagogiques numériques",
      ],
      evaluation: [
        "Évaluation continue des compétences pratiques",
        "Examen final avec mises en situation et tests écrits",
        "Délivrance d’un certificat SST valable 2 ans",
      ],
      methods: [
        "Cours interactifs en salle avec supports visuels",
        "Démonstrations pratiques des gestes de premiers secours",
        "Mises en situation réalistes pour appliquer les connaissances acquises",
        "Encadrement par des formateurs certifiés SST",
      ],
      trainer:
        "Formateurs agréés SST, experts en prévention des risques et premiers secours",
    },
    {
      title: "Stratégies de Marketing Digital",
      objectives: [
        "Découvrir les leviers incontournables du marketing digital pour propulser votre activité",
        "Construire une stratégie digitale performante, adaptée à vos objectifs",
        "Maîtriser les outils et techniques pour attirer, convertir et fidéliser vos clients",
        "Analyser vos résultats et optimiser vos campagnes en temps réel",
      ],
      content: [
        "🔍 Introduction au marketing digital : enjeux et opportunités",
        "🌐 Panorama des canaux digitaux : SEO, SEA, réseaux sociaux, emailing, etc.",
        "✍️ Créer une stratégie de contenu impactante",
        "📣 Publicité en ligne : Google Ads, Meta Ads & stratégies d'acquisition",
        "🧠 UX & CRO : améliorer l'expérience utilisateur pour convertir plus",
        "📊 Mesure et analyse : Google Analytics, KPI, reporting",
        "🤖 Marketing automation : gagner en efficacité tout en restant pertinent",
        "📱 Tendances actuelles : IA, vidéo marketing, influence, mobile-first",
        "🚀 Construire un plan d’action digital adapté à votre entreprise",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites:
        "Aucun prérequis — motivation et curiosité sont les bienvenues !",
      accessibility:
        "Formations accessibles aux personnes à mobilité réduite, en présentiel ou à distance.",
      materials: [
        "Un ordinateur ou une tablette",
        "Une connexion Internet pour la formation en ligne",
        "Un carnet ou bloc-notes pour la prise de notes",
      ],
      evaluation: [
        "Quiz interactifs et auto-évaluation à chaque module",
        "Exercices pratiques et mises en situation",
        "Questionnaire de positionnement et évaluation à chaud",
      ],
      methods: [
        "Formation disponible en présentiel ou à distance selon les besoins",
        "Cours dispensés via des modules vidéo ou sessions en direct",
        "Études de cas, partages d’expérience et échanges interactifs",
        "Accompagnement par un formateur référent disponible pendant la formation",
      ],
      trainer:
        "Formateurs passionnés et expérimentés en marketing digital, intervenant auprès de publics variés et d’entreprises de toutes tailles",
    },
    {
      title: "Intelligence Artificielle (IA)",
      objectives: [
        "Comprendre les concepts fondamentaux de l’intelligence artificielle",
        "Explorer les différentes applications de l’IA dans divers domaines",
        "Apprendre les bases du machine learning et du deep learning",
        "Manipuler des outils et bibliothèques couramment utilisés en IA (TensorFlow, PyTorch, Scikit-learn)",
        "Développer des modèles d’IA pour résoudre des problèmes concrets",
      ],
      content: [
        "Introduction à l’intelligence artificielle et historique",
        "Les différentes branches de l’IA : machine learning, deep learning, NLP, vision par ordinateur",
        "Les algorithmes d’apprentissage supervisé et non supervisé",
        "Manipulation de bases de données et prétraitement des données",
        "Création et entraînement de modèles d’IA avec Python",
        "Optimisation des modèles et évaluation des performances",
        "Applications pratiques de l’IA (chatbots, reconnaissance faciale, analyse prédictive)",
        "Défis éthiques et enjeux de l’IA",
      ],
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Notions de programmation recommandées (Python)",
      accessibility:
        "Formation accessible aux débutants comme aux initiés, avec supports adaptés",
      materials: [
        "Ordinateur avec environnement de développement configuré (Jupyter Notebook, Google Colab)",
        "Accès aux datasets et bibliothèques IA",
        "Supports de cours et tutoriels vidéo",
      ],
      evaluation: [
        "Évaluations pratiques sous forme de mini-projets IA",
        "Quiz et tests de compréhension",
        "Projet final d’application d’un modèle d’IA sur un cas réel",
      ],
      methods: [
        "Cours théoriques et démonstrations pratiques",
        "Ateliers de programmation et études de cas",
        "Encadrement par des experts en intelligence artificielle",
        "Travaux dirigés et projets collaboratifs",
      ],
      trainer:
        "Formateurs spécialisés en IA et data science, chercheurs et ingénieurs IA",
    },
    {
      title: "Kinésithérapie en Réhabilitation Respiratoire",
      objectives: [
        "Définir et comprendre l’insuffisance respiratoire (IR)",
        "Connaître les indications, les modalités et les techniques de la réhabilitation respiratoire",
        "Savoir utiliser les différents outils d’évaluation pluridisciplinaires et physiques",
        "Elaborer un programme personnalisé pour le patient en fonction des bilans",
        "Prescrire les outils d’aide au sevrage tabagique",
        "Assurer l’éducation thérapeutique du patient",
      ],
      content: [
        "La fonction ventilatoire",
        "L'insuffisance respiratoire chronique",
        "Aspects physiopathologiques",
        "La réhabilitation respiratoire",
        "Evaluation du patient",
        "Evaluations fonctionnelles du patient",
        "Construction du programme de réhabilitation",
        "Aide au sevrage tabagique",
        "Entrainement physique",
        "Oxygénothérapie",
        "Kinésithérapie respiratoire",
        "Education et suivi du patient",
        "Maintien à long terme",
      ],
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations accessibles en ligne, adaptées aux personnes à mobilité réduite",
      materials: [
        "Un ordinateur ou une tablette pour accéder aux cours en ligne",
        "Connexion Internet pour accéder au contenu et aux ressources",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous forme d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Formateurs experts en kinésithérapie respiratoire et réhabilitation des patients.",
    },
    {
      title: "Langue Anglais - Débutant (A1-A2)",
      objectives: [
        "Acquérir les fondamentaux de la conjugaison et de la grammaire anglaises",
        "Acquérir les bases du vocabulaire anglais",
        "Comprendre et utiliser des expressions courantes et quotidiennes",
        "Se présenter ou présenter autrui",
        "Communiquer de façon simple",
      ],
      content: [
        "Le verbe To Be et les pronoms personnels",
        "Saluer quelqu’un et faire connaissance",
        "Le verbe To have",
        "La famille",
        "Les adjectifs possessifs",
        "Les numéros",
        "There is et There are",
        "Poser des questions",
        "Les noms dénombrables et indénombrables",
        "Le Présent Simple",
        "Décrire son métier",
        "Le present Continuous",
        "Comment vous sentez-vous ?",
        "Le passé simple régulier et irrégulier",
        "Le temps et les saisons",
        "Les prépositions de temps et lieu",
        "Les lieux dans la ville",
        "Indiquer la date ou l’heure",
        "Les adjectifs comparatifs et superlatifs",
        "Les couleurs et les formes",
        "Les adverbes et adverbes de fréquence",
        "Parler des goûts",
        "Le futur avec Will",
        "Le past continuous",
        "Le present perfect",
        "Demander et indiquer le chemin",
        "Les phrases verbales",
        "Les pronoms toniques",
        "Les sons difficiles en anglais",
      ],
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },

    {
      title: "Langue Anglais - Intermédiaire (B1-B2)",
      objectives: [
        "Comprendre les points essentiels d’une discussion",
        "Être autonome dans la plupart des situations où la langue cible est parlée",
        "Pouvoir produire un discours simple et cohérent sur des sujets familiers",
        "Savoir raconter un événement, une expérience",
      ],
      content: [
        "Verbes modaux",
        "Modals passés",
        "Donner des commandes et des conseils",
        "Présent parfait continu",
        "Futur continu",
        "Comparatifs et superlatifs",
        "Plus-que-parfait",
        "Passé parfait continu",
        "Conditionnel / conditionnel continu",
        "Conditionnel parfait / conditionnel parfait continu",
        "Premier et deuxième conditionnel",
        "Deuxième et troisième conditionnel",
        "Décrire des endroits",
        "Décrire les gens",
        "Décrire les espoirs et les projets",
        "Exprimer son opinion",
        "Conjonctions de coordination",
        "Mode interrogatif",
        "Faire des récits",
        "La colocation",
        "Les voyages",
        "Les loisirs",
        "Le restaurant",
        "La santé",
        "Diriger et gérer les discussions",
      ],
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue Anglais - Avancé (C1-C2)",
      objectives: [
        "Comprendre des textes complexes et longs",
        "S'exprimer spontanément et couramment sans trop chercher ses mots",
        "Utiliser la langue de manière souple et efficace dans la vie sociale, académique ou professionnelle",
        "Produire un discours clair, bien structuré et détaillé sur des sujets complexes",
      ],
      content: [
        "Nuances des temps du passé",
        "Expressions idiomatiques et phrasal verbs avancés",
        "Discours indirect et rapporté",
        "Structures conditionnelles avancées",
        "Les tournures emphatiques",
        "Expressions de la concession et de l’opposition",
        "Techniques de rédaction avancée",
        "Compréhension et analyse de textes littéraires",
        "Prise de parole en public",
        "Débats et argumentation",
        "Négociation et persuasion",
        "Langage formel et informel",
        "Stratégies de compréhension orale avancée",
      ],
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Niveau B2 requis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue Anglais - Médical (A1-A2)",
      objectives: [
        "Acquérir les bases de la communication médicale en anglais",
        "Comprendre et utiliser des expressions courantes dans un contexte médical",
        "Enrichir le vocabulaire avec des termes médicaux spécifiques",
        "Développer les compétences nécessaires pour interagir efficacement dans des contextes cliniques anglophones",
      ],
      content: [
        "Le verbe To Be et les pronoms personnels",
        "Saluer quelqu’un et faire connaissance",
        "Le verbe To have",
        "La famille",
        "Les adjectifs possessifs",
        "Les numéros",
        "There is et There are",
        "Poser des questions",
        "Les noms dénombrables et indénombrables",
        "Le Présent Simple",
        "Décrire son métier",
        "Le present Continuous",
        "Comment vous sentez-vous ?",
        "Le passé simple régulier et irrégulier",
        "Le temps et les saisons",
        "Les prépositions de temps et lieu",
        "Les lieux dans la ville",
        "Indiquer la date ou l’heure",
        "Les adjectifs comparatifs et superlatifs",
        "Les couleurs et les formes",
        "Les adverbes et adverbes de fréquence",
        "Parler des goûts",
        "Le futur avec Will",
        "Le past continuous",
        "Le present perfect",
        "Demander et indiquer le chemin",
        "Les phrases verbales",
        "Les pronoms toniques",
        "Les sons difficiles en anglais",
        "Admission et Bilan",
        "La douleur",
        "Les soins relationnels",
        "L'anatomie",
        "L'anatomie partie 2",
        "Les instructions",
        "Les soins techniques",
        "Les spécialités",
        "L'équipement",
        "La médication",
        "Les régimes",
        "Lexique médical",
      ],
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue Anglais - Médical (B1-B2)",
      objectives: [
        "Comprendre les points essentiels d’une discussion quand un langage clair et standard est utilisé",
        "Pouvoir produire un discours simple et cohérent sur des sujets familiers et dans ses domaines d’intérêt",
        "Communiquer dans le domaine médical",
        "Savoir raconter un événement, une expérience",
      ],
      content: [
        "Verbes modaux",
        "Modals passés",
        "Donner des commandes et des conseils",
        "Présent parfait continu",
        "Futur continu",
        "Comparatifs et superlatifs",
        "Plus-que-parfait",
        "Passé parfait continu",
        "Conditionnel / conditionnel continu",
        "Conditionnel parfait / conditionnel parfait continu",
        "Premier et deuxième conditionnel",
        "Le present Continuous",
        "Deuxième et troisième conditionnel",
        "Décrire des endroits",
        "Décrire les gens",
        "Décrire les espoirs et les projets",
        "Exprimer son opinion",
        "Conjonctions de coordination",
        "Mode interrogatif",
        "Faire des récits",
        "La colocation",
        "Les voyages",
        "Les loisirs",
        "Le restaurant",
        "La santé",
        "Diriger et gérer les discussions",
        "Admission et Bilan",
        "La douleur",
        "Les soins relationnels",
        "L'anatomie",
        "L'anatomie partie 2",
        "Les instructions",
        "Les soins techniques",
        "Les spécialités",
        "L'équipement",
        "La médication",
        "Les régimes",
        "Lexique médical",
      ],
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue Anglais Langue Étrangère - Niveau Débutant",
      objectives: [
        "Développer une compréhension fondamentale de la langue anglaise",
        "Apprendre à exprimer les pays et nationalités en anglais",
        "Se décrire soi-même et parler de sa famille et de ses amis en anglais",
        "Explorer des sujets liés à la vie quotidienne et aux routines",
        "Acquérir de l’aisance pour discuter du temps et des horaires en anglais",
      ],
      content: [
        "Les bases de l'anglais",
        "Les pays et nationalités",
        "Tout sur vous",
        "La famille et les amis",
        "La façon dont je vis",
        "L'heure en anglais",
        "Mes préférences",
        "Où je vis",
        "Les temps passés",
        "Nous avons passé un bon moment",
        "Je peux le faire !",
        "S'il vous plaît et merci",
        "Ici et maintenant",
        "Il est temps de partir",
        "Bonjour tout le monde",
        "Rencontrer des gens",
        "Parlons du futur",
        "À quelle fréquence faites-vous de l'exercice ?",
        "Où habitez-vous ?",
        "Parlez-vous anglais ?",
        "Maintenant et avant",
        "Les FANBOYS",
        "Les aliments que j'aime",
        "Plus grand et mieux",
        "Bien paraître",
        "Avez-vous déjà ?",
        "Faire connaissance",
        "La façon dont nous vivons",
        "La vie est une aventure",
        "Allez, tu peux le faire !",
      ],
      accessibility:
        "Formation à distance accessible aux personnes à mobilité réduite. Pour toute question d'accessibilité liée à un handicap, contactez-nous.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: [
        "Ordinateur ou tablette avec connexion Internet",
        "Connexion web",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous forme d’ateliers pratiques",
        "Questionnaire de positionnement",
        "Évaluation à chaud",
      ],
      methods: [
        "Accès en ligne au cours",
        "Cours théoriques au format vidéo",
        "Formation accessible via un ordinateur ou une tablette",
      ],
      trainer:
        "Plusieurs années d'expérience dans l'enseignement de cette discipline",
    },
    {
      title: "Langue Anglais Langue Étrangère - Niveau Avancé",
      objectives: [
        "Maîtriser le système des temps en anglais et éviter les erreurs courantes avec le présent",
        "Comprendre et appliquer les temps narratifs pour raconter des histoires efficacement",
        "Apprendre les différents types de phrases et leur rôle dans les phrases",
        "Utiliser avec compétence les diverses formes du futur pour exprimer les événements futurs",
        "Acquérir une expertise en grammaire anglaise, y compris les structures de phrases",
      ],
      content: [
        "Le système des temps",
        "Les erreurs les plus courantes avec le présent",
        "Les temps narratifs",
        "Différents types de phrases",
        "Les formes du futur",
        "Les types de phrases",
        "Questions déclaratives vs questions rhétoriques",
        "Les noms en anglais",
        "Terminer une phrase par une préposition",
        "Les adverbes",
        "Les modes du verbe",
        "Les articles",
      ],
      accessibility:
        "Formation à distance accessible aux personnes à mobilité réduite. Pour toute question d'accessibilité liée à un handicap, contactez-nous.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: [
        "Ordinateur ou tablette avec connexion Internet",
        "Connexion web",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous forme d’ateliers pratiques",
        "Questionnaire de positionnement",
        "Évaluation à chaud",
      ],
      methods: [
        "Accès en ligne au cours",
        "Cours théoriques au format vidéo",
        "Formation accessible via un ordinateur ou une tablette",
      ],
      trainer:
        "Plusieurs années d'expérience dans l'enseignement de cette discipline",
    },
    {
      title: "Langue Anglais Professionnel Langue Étrangère",
      objectives: [
        "Développer de solides compétences en rédaction de CV et de lettres de motivation pour des candidatures efficaces",
        "Acquérir de l'aisance en communication écrite et orale",
        "Comprendre les dynamiques du lieu de travail, le service client, la négociation, et diverses situations professionnelles",
      ],
      content: [
        "CV et lettres de motivation",
        "Qu'est-ce qu'un CV ?",
        "Entretiens d'embauche",
        "Emails",
        "Réunions",
        "Présentations",
        "Rapports professionnels",
        "Service client - Premières impressions",
        "Service client téléphonique",
        "Négociation",
        "Gérer les relations avec les collègues au travail",
        "Voyages d'affaires",
        "Postes de travail",
        "Gestion hiérarchique",
        "Quitter son emploi",
        "Le processus d'évaluation annuelle",
        "Arriver en retard au travail",
        "Types d'entreprises",
      ],
      accessibility:
        "Formation à distance accessible aux personnes à mobilité réduite. Pour toute question d'accessibilité liée à un handicap, contactez-nous.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: [
        "Ordinateur ou tablette avec connexion Internet",
        "Connexion web",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous forme d’ateliers pratiques",
        "Questionnaire de positionnement",
        "Évaluation à chaud",
      ],
      methods: [
        "Accès en ligne au cours",
        "Cours théoriques au format vidéo",
        "Formation accessible via un ordinateur ou une tablette",
      ],
      trainer:
        "Plusieurs années d'expérience dans l'enseignement de cette discipline",
    },
    {
      title: "Préparation à l'Examen Anglais - TOEIC",
      objectives: [
        "Maîtriser les bases du TOEIC",
        "Exceller dans les sections 'Listening' et 'Reading' du TOEIC",
        "Perfectionner l'expression orale pour la section 'Speaking'",
        "Appliquer des stratégies de résolution de problèmes pour la réussite du TOEIC",
      ],
      content: [
        "Introduction",
        "Présentation de l'examen",
        "Conseils et astuces",
        "Exercices de lecture et d'écoute",
        "Expression orale et écrite",
        "Conclusion",
      ],
      accessibility:
        "Formation à distance accessible aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous forme d’ateliers pratiques",
        "Questionnaire de positionnement",
        "Évaluation à chaud",
      ],
      methods: [
        "Accès en ligne au cours",
        "Cours théoriques au format vidéo",
        "Formation accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Préparation à l'Examen Anglais - Cambridge",
      objectives: [
        "Acquérir une compréhension approfondie de l'examen Cambridge",
        "Se familiariser avec les sections 'Speaking' et 'Writing' de l'examen",
        "Savoir appliquer des stratégies efficaces de résolution de problèmes",
        "Améliorer les compétences en expression orale et écrite",
      ],
      content: [
        "Module 0 - Introduction",
        "Module 1 - Présentation de l'examen",
        "Module 2 - Conseils et astuces",
        "Module 3 - Exercices",
        "Module 4 - Exercices",
        "Module 5 - Conclusion",
      ],
      accessibility:
        "Formation à distance accessible aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous forme d’ateliers pratiques",
        "Questionnaire de positionnement",
        "Évaluation à chaud",
      ],
      methods: [
        "Accès en ligne au cours",
        "Cours théoriques au format vidéo",
        "Formation accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Préparation à l'Examen Anglais - IELTS",
      objectives: [
        "Acquérir une compréhension approfondie de l'examen IELTS",
        "Se familiariser avec les sections 'Speaking' et 'Writing' de l'examen",
        "Savoir appliquer des stratégies efficaces de résolution de problèmes",
        "Améliorer les compétences en expression orale et écrite",
      ],
      content: [
        "Module 0 - Introduction",
        "Module 1 - Présentation de l'examen",
        "Module 2 - Conseils et astuces",
        "Module 3 - Exercices",
        "Module 4 - Exercices",
        "Module 5 - Conclusion",
      ],
      accessibility:
        "Formation à distance accessible aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous forme d’ateliers pratiques",
        "Questionnaire de positionnement",
        "Évaluation à chaud",
      ],
      methods: [
        "Accès en ligne au cours",
        "Cours théoriques au format vidéo",
        "Formation accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Préparation à l'Examen Anglais - Linguaskill",
      objectives: [
        "Acquérir une compréhension approfondie de l'examen Linguaskill",
        "Se familiariser avec les sections 'Speaking' et 'Writing' de l'examen",
        "Savoir appliquer des stratégies efficaces de résolution de problèmes",
        "Améliorer les compétences en expression orale et écrite",
      ],
      content: [
        "Module 0 - Introduction",
        "Module 1 - Présentation de l'examen",
        "Module 2 - Conseils et astuces",
        "Module 3 - Exercices",
        "Module 4 - Exercices",
        "Module 5 - Conclusion",
      ],
      accessibility:
        "Formation à distance accessible aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous forme d’ateliers pratiques",
        "Questionnaire de positionnement",
        "Évaluation à chaud",
      ],
      methods: [
        "Accès en ligne au cours",
        "Cours théoriques au format vidéo",
        "Formation accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Préparation à l'Examen Anglais - TOEFL",
      objectives: [
        "Acquérir une compréhension approfondie de l'examen TOEFL",
        "Se familiariser avec les sections 'Speaking' et 'Writing' de l'examen",
        "Savoir appliquer des stratégies efficaces de résolution de problèmes",
        "Améliorer les compétences en expression orale et écrite",
      ],
      content: [
        "Module 1 - Présentation de l'examen",
        "Module 2 - Conseils et astuces",
        "Module 3 - Exercices reading and listening",
        "Module 4 - Speaking and writing",
      ],
      accessibility:
        "Formation à distance accessible aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous forme d’ateliers pratiques",
        "Questionnaire de positionnement",
        "Évaluation à chaud",
      ],
      methods: [
        "Accès en ligne au cours",
        "Cours théoriques au format vidéo",
        "Formation accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Préparation à l'Examen Anglais - IELTS",
      objectives: [
        "Acquérir une compréhension approfondie de l'examen IELTS",
        "Se familiariser avec les sections 'Speaking' et 'Writing' de l'examen",
        "Savoir appliquer des stratégies efficaces de résolution de problèmes",
        "Améliorer les compétences en expression orale et écrite",
      ],
      content: [
        "Module 0 - Introduction",
        "Module 1 - Présentation de l'examen",
        "Module 2 - Conseils et astuces",
        "Module 3 - Exercices",
        "Module 4 - Exercices",
        "Module 5 - Conclusion",
      ],
      accessibility:
        "Formation à distance accessible aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous forme d’ateliers pratiques",
        "Questionnaire de positionnement",
        "Évaluation à chaud",
      ],
      methods: [
        "Accès en ligne au cours",
        "Cours théoriques au format vidéo",
        "Formation accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Préparation à l'Examen Anglais - Linguaskill",
      objectives: [
        "Acquérir une compréhension approfondie de l'examen Linguaskill",
        "Se familiariser avec les sections 'Speaking' et 'Writing' de l'examen",
        "Savoir appliquer des stratégies efficaces de résolution de problèmes",
        "Améliorer les compétences en expression orale et écrite",
      ],
      content: [
        "Module 0 - Introduction",
        "Module 1 - Présentation de l'examen",
        "Module 2 - Conseils et astuces",
        "Module 3 - Exercices",
        "Module 4 - Exercices",
        "Module 5 - Conclusion",
      ],
      accessibility:
        "Formation à distance accessible aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous forme d’ateliers pratiques",
        "Questionnaire de positionnement",
        "Évaluation à chaud",
      ],
      methods: [
        "Accès en ligne au cours",
        "Cours théoriques au format vidéo",
        "Formation accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Préparation à l'Examen Anglais - TOEFL",
      objectives: [
        "Acquérir une compréhension approfondie de l'examen TOEFL",
        "Se familiariser avec les sections 'Speaking' et 'Writing' de l'examen",
        "Savoir appliquer des stratégies efficaces de résolution de problèmes",
        "Améliorer les compétences en expression orale et écrite",
      ],
      content: [
        "Module 1 - Présentation de l'examen",
        "Module 2 - Conseils et astuces",
        "Module 3 - Exercices reading and listening",
        "Module 4 - Speaking and writing",
      ],
      accessibility:
        "Formation à distance accessible aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous forme d’ateliers pratiques",
        "Questionnaire de positionnement",
        "Évaluation à chaud",
      ],
      methods: [
        "Accès en ligne au cours",
        "Cours théoriques au format vidéo",
        "Formation accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue Allemand - Débutant (A1-A2)",
      objectives: [
        "Acquérir les fondamentaux de la conjugaison et de la grammaire allemande",
        "Acquérir les bases du vocabulaire allemand",
        "Comprendre et utiliser des expressions courantes et quotidiennes",
        "Se présenter ou présenter autrui",
        "Communiquer de façon simple",
      ],
      content: [
        "Module 1 - Les verbes du premier et deuxième groupe",
        "Module 2 - Les articles définis et indéfinis",
        "Module 3 - Se situer dans le temps",
        "Module 4 - Le passé composé – Part 1",
        "Module 5 - Les articles partitifs et les quantités définies",
      ],
      accessibility:
        "Formation à distance accessible aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous forme d’ateliers pratiques",
        "Questionnaire de positionnement",
        "Évaluation à chaud",
      ],
      methods: [
        "Accès en ligne au cours",
        "Cours théoriques au format vidéo",
        "Formation accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue Arabe - Débutant (A1-A2)",
      objectives: [
        "Acquérir les fondamentaux de la grammaire arabe",
        "Acquérir les bases du vocabulaire arabe",
        "Comprendre et utiliser des expressions courantes",
        "Se présenter ou présenter autrui",
        "Communiquer de façon simple",
      ],
      content: [
        "Alphabet 1_5",
        "Voyelles courtes",
        "Le sukun",
        "Les voyelles longues",
        "Le tanwin",
        "Vocabulaire 1_2",
      ],
      accessibility:
        "Formation à distance accessible aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous forme d’ateliers pratiques",
        "Questionnaire de positionnement",
        "Évaluation à chaud",
      ],
      methods: [
        "Accès en ligne au cours",
        "Cours théoriques au format vidéo",
        "Formation accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue Arabe - Intermédiaire (B1-B2)",
      objectives: [
        "Comprendre l’essentiel d’une discussion en langage clair et standard",
        "Être autonome dans la plupart des situations où la langue cible est parlée",
        "Produire un discours simple et cohérent sur des sujets familiers",
        "Savoir raconter un événement, une expérience",
      ],
      content: [
        "Les adjectifs démonstratifs pour le lointain",
        "Les prépositions et les pronoms affixes",
        "Le pluriel irrégulier",
        "La conjugaison du verbe lorsqu'il précède le sujet",
        "L’utilisation des interrogatifs",
        "Un dialogue à l'aéroport",
      ],
      accessibility:
        "Formation à distance accessible aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous forme d’ateliers pratiques",
        "Questionnaire de positionnement",
        "Évaluation à chaud",
      ],
      methods: [
        "Accès en ligne au cours",
        "Cours théoriques au format vidéo",
        "Formation accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue Espagnol - Débutant (A1-A2)",
      objectives: [
        "Acquérir les fondamentaux de la grammaire espagnole",
        "Acquérir les bases du vocabulaire espagnol",
        "Comprendre et utiliser des expressions courantes",
        "Se présenter ou présenter autrui",
        "Communiquer de façon simple",
      ],
      content: [
        "Se présenter",
        "Les nationalités et les langues",
        "Saluer, prendre congé",
        "Les états émotionnels",
        "Le présent de l'indicatif (1)",
        "Les professions",
        "Le présent de l'indicatif (2)",
        "Les articles, le genre",
        "Les verbes pronominaux",
        "Exprimer ses goûts et ses préférences",
        "L’heure et la date",
        "L’obligation en espagnol",
        "Le superlatif/le comparatif",
        "Les vêtements, les accessoires et les couleurs",
        "Le passé composé",
        "Le climat et les expressions de fréquence",
        "L’imparfait",
        "Les démonstratifs et les prépositions de lieu",
        "Le futur proche",
        "Les aliments et la gastronomie dans le monde hispanophone",
      ],
      accessibility:
        "Formation à distance accessible aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous forme d’ateliers pratiques",
        "Questionnaire de positionnement",
        "Évaluation à chaud",
      ],
      methods: [
        "Accès en ligne au cours",
        "Cours théoriques au format vidéo",
        "Formation accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue Espagnol - Intermédiaire (B1-B2)",
      objectives: [
        "Comprendre des discussions courantes sur des sujets familiers",
        "Être autonome en voyage dans des régions parlant la langue cible",
        "Produire un discours cohérent sur des sujets personnels et familiers",
        "Raconter des événements, exprimer des espoirs et expliquer des projets",
      ],
      content: [
        "Estar + gerundio",
        "Por et para",
        "Le conditionnel",
        "Quien, que, cuyo, donde",
        "Le passé simple régulier",
        "Le passé simple irrégulier",
        "Le passé simple vs. Le passé composé",
        "Les prépositions pièges",
        "Le plus-que-parfait, pero vs. sino",
        "Le passé simple, l’imparfait et le plus-que-parfait",
        "Le subjonctif régulier",
        "Le subjonctif irrégulier",
        "L’impératif",
        "Le ‘se’ impersonnel",
        "Complément direct",
        "Complément indirect/les deux",
        "Les superstitions + subjonctif",
        "Le subjonctif imparfait",
        "Les phrases conditionnelles",
        "L’avenir : les hypothèses sur l’avenir avec le subjonctif et les phrases conditionnelles",
      ],
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue Espagnol - Avancé (C1-C2)",
      objectives: [
        "Mener une conversation quotidienne en espagnol",
        "Acquérir un vocabulaire riche",
        "Voyager aisément dans les pays hispanophones",
        "Maîtriser la grammaire espagnole",
        "Gérer des échanges commerciaux complexes",
      ],
      content: [
        "Adjectifs avec double signification",
        "Voix active et passive",
        "Le passé antérieur de l'indicatif",
        "Les pronoms Leisom, Loismo et Laismo",
        "Le futur composé",
        "Les verbes de changement",
        "Le passé du subjonctif",
        "Le style indirect",
        "Périphrases verbales et verbes modaux",
        "Les marqueurs de conversation et argumentation",
        "Les collègues de travail",
        "Le service client",
        "Présenter une entreprise",
        "Présenter les règles d'une entreprise",
        "Salons et foires",
        "Écrire un courrier informel",
        "La négociation",
        "La stratégie publicitaire",
        "L'entretien d'embauche",
        "Parler en public",
      ],
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Préparation à l’Examen Espagnol DELE",
      objectives: [
        "Introduire les concepts et les applications de DELE aux apprenants",
        "Fournir des conseils pratiques aux apprenants en mettant l'accent sur les stratégies efficaces pour préparer et réussir l'examen DELE",
      ],
      content: [
        "La Présentation",
        "Les conseils",
        "Niveau A1-A2",
        "Niveau B1-B2",
        "Niveau C1-C2",
        "Conclusion",
      ],
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Préparation à l’Examen Espagnol SIELE",
      objectives: [
        "Améliorer les compétences de présentation, de communication écrite et orale",
        "Développer les aptitudes de compréhension de lecture et auditive",
        "Renforcer leur capacité à s'exprimer de manière claire et persuasive",
        "Les préparer à l’examen espagnol SIELE",
      ],
      content: [
        "La Présentation",
        "Les conseils",
        "Compréhension de lecture et auditive",
        "Expression et interactions écrites et orales",
        "Conclusion",
      ],
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue Français Langue Étrangère (FLE) Niveau A1-A2",
      objectives: [
        "Développer des compétences linguistiques orales et écrites inhérentes à la vie quotidienne et à l’environnement professionnel",
        "Acquérir des compétences culturelles et socio-langagières visant à faciliter l’intégration sociale et économique",
        "Enrichir son vocabulaire et éviter les fautes les plus courantes du français dans ses écrits professionnels",
      ],
      content: [
        "Introduction au niveau A1-A2",
        "Les verbes du 1er et 2e groupe",
        "Les verbes du 3e groupe",
        "Les nombres de 1 à 100",
        "Les verbes être, avoir et aller",
        "Les articles définis et indéfinis",
        "Les consonnes finales",
        "Les articles contractés",
        "La négation",
        "Se situer dans le temps",
        "Le futur proche et le futur simple",
        "Poser des questions",
        "Vouloir, pouvoir, devoir et falloir",
        "Le passé composé",
        "La négation et le passé composé",
        "L'imparfait",
        "Les articles partitifs et les quantités définies",
        "Les adjectifs démonstratifs et possessifs",
        "Les prépositions",
        "Conclusion sur le programme A1-A2",
        "Préparation au DELF",
        "Introduction",
        "Description de l'épreuve",
        "La compréhension",
        "L'expression",
        "Exemples concrets",
        "Les barèmes",
      ],
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue Français Langue Étrangère (FLE) Niveau A1-A2",
      objectives: [
        "Développer des compétences linguistiques orales et écrites inhérentes à la vie quotidienne et à l’environnement professionnel",
        "Acquérir des compétences culturelles et socio-langagières visant à faciliter l’intégration sociale et économique",
        "Enrichir son vocabulaire et éviter les fautes les plus courantes du français dans ses écrits professionnels",
      ],
      content: [
        "Introduction au niveau A1-A2",
        "Les verbes du 1er et 2e groupe",
        "Les verbes du 3e groupe",
        "Les nombres de 1 à 100",
        "Les verbes être, avoir et aller",
        "Les articles définis et indéfinis",
        "Les consonnes finales",
        "Les articles contractés",
        "La négation",
        "Se situer dans le temps",
        "Le futur proche et le futur simple",
        "Poser des questions",
        "Vouloir, pouvoir, devoir et falloir",
        "Le passé composé",
        "La négation et le passé composé",
        "L'imparfait",
        "Les articles partitifs et les quantités définies",
        "Les adjectifs démonstratifs et possessifs",
        "Les prépositions",
        "Conclusion sur le programme A1-A2",
        "Préparation au DELF",
        "Introduction",
        "Description de l'épreuve",
        "La compréhension",
        "L'expression",
        "Exemples concrets",
        "Les barèmes",
      ],
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue Français Langue Étrangère (FLE) Niveau B1",
      objectives: [
        "Maîtriser la langue française au niveau B1, y compris les compétences orales et écrites",
        "Renforcer les connaissances grammaticales et enrichir le vocabulaire",
        "Acquérir des compétences en communication dans un contexte professionnel et personnel",
      ],
      content: [
        "Introduction au niveau B1",
        "Les temps du passé et du futur",
        "Les verbes réfléchis et réciproques",
        "Les prépositions et leur utilisation",
        "Les expressions idiomatiques",
        "Les articles définis et indéfinis dans différents contextes",
        "Les constructions causatives",
        "La concordance des temps",
        "Les phrases complexes",
        "L’expression de l’opinion",
        "La rédaction d’un email professionnel",
        "La présentation orale",
        "Préparation au DELF",
        "Exemples de tests DELF",
        "Les techniques de compréhension orale",
        "Les stratégies d’écriture",
      ],
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Niveau A2 requis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Exercices interactifs",
        "Travaux écrits et oraux",
        "Évaluation finale du niveau de compétence",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Ateliers pratiques en ligne",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Formateur expérimenté en FLE avec une approche pédagogique axée sur la pratique",
    },
    {
      title: "Langue Italien - Débutant (A1-A2)",
      objectives: [
        "Acquérir les fondamentaux de la grammaire italienne",
        "Acquérir les bases du vocabulaire italien",
        "Comprendre et utiliser des expressions courantes",
        "Se présenter ou présenter autrui",
        "Communiquer de façon simple",
      ],
      content: [
        "Presentarsi - Se présenter",
        "Oggetti - Objets",
        "L'età - L'âge",
        "Salutarsi - Salutations",
        "La giornata - La journée",
        "Prenotare - Réserver",
        "Al ristorante - Au restaurant",
        "Il migliore - Le meilleur",
        "Mi piace - J'aime",
        "Ieri - Hier",
        "Istruzioni - Instructions",
        "Dal medico - Chez le médecin",
        "Domani - Demain",
        "La famiglia - La famille",
        "Da piccolo... - Quand j'étais petit...",
        "Già fatto - Déjà fait",
        "La spesa - Les courses",
        "I vestiti - Les vêtements",
        "Aiutami - Aide-moi",
        "Consigli e soluzioni - Conseils et solutions",
        "Casa - Maison",
        "Me piace - Ça me plaît",
        "Me la cavo ! - Je m'en sors !",
      ],
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: ["Ordinateur ou tablette avec connexion Internet"],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue Japonais - Débutant (A1-A2)",
      objectives: [
        "Initiation aux fondements de la culture japonaise",
        "Acquérir les fondamentaux de la grammaire japonaise",
        "Acquérir les bases du vocabulaire japonais",
        "Comprendre et utiliser des expressions courantes et quotidiennes",
        "Se présenter ou présenter autrui",
        "Communiquer de façon simple",
      ],
      content: [
        "Le japon et la langue",
        "La phrase basique",
        "L’écriture",
        "Poser une question",
        "La négation",
        "Les démonstratifs",
        "Les adjectifs variables / invariables",
        "Les conjugaisons",
        "Les particules verbales",
        "La particule GA",
        "L’heure",
        "Les verbes intransitifs",
        "La forme TE",
        "La forme suspensive",
        "Les autorisations et les interdictions",
        "Le comparatif",
        "La volonté",
        "Guider quelqu’un",
        "Les propositions relatives",
        "La nominalisation",
        "L’expérience",
        "La cause",
      ],
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue des Signes Française - Niveau A1-A2",
      objectives: [
        "Développer des compétences linguistiques orales et écrites inhérentes à la vie quotidienne et à l’environnement professionnel",
        "Acquérir des compétences culturelles et socio-langagières visant à faciliter l’intégration sociale et économique",
        "Enrichir son vocabulaire et éviter les fautes les plus courantes du français dans ses écrits professionnels",
      ],
      content: [
        "Introduction au niveau A1-A2 de la LSF",
        "L'histoire et la culture sourde",
        "La base en LSF",
        "Les notions fondamentales en LSF",
        "Se présenter",
        "Vocabulaire",
        "Les métiers",
        "La grammaire",
        "S'intéresser à son interlocuteur",
        "La notion de temps",
        "Compter",
        "Les jours",
        "Les mois",
        "Les dates",
        "Les heures",
        "La durée",
        "Description et utilisation de l'espace",
        "Les éléments physiques et les couleurs",
        "Les moyens de transport",
        "Les expressions",
        "Les verbes",
        "La syntaxe",
      ],
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue Portugais - Débutant (A1-A2)",
      objectives: [
        "Acquérir les fondamentaux de la conjugaison et de la grammaire portugaise",
        "Acquérir les bases du vocabulaire portugais",
        "Comprendre et utiliser des expressions courantes et quotidiennes",
        "Se présenter ou présenter autrui",
        "Communiquer de façon simple",
      ],
      content: [
        "Présentation 1",
        "Bonus phonétique",
        "Présentation 2",
        "Informations personnelles",
        "La famille",
        "Fixer un rendez-vous",
        "La routine",
        "La météo",
        "Révisions",
        "La nourriture",
        "Le sport",
        "Les loisirs",
        "La ville et les transports",
        "La description",
        "Les métiers",
        "Au restaurant",
        "Les émotions",
        "Les vêtements",
        "La routine",
        "Les voyages",
        "L’hôtel",
        "La maison",
        "Une bêtise",
        "Un billet de train",
      ],
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Langue Russe - Débutant (A1-A2)",
      objectives: [
        "Acquérir les fondamentaux de la grammaire russe",
        "Acquérir les bases du vocabulaire russe",
        "Comprendre et utiliser des expressions courantes",
        "Se présenter ou présenter autrui",
        "Communiquer de façon simple",
      ],
      content: [
        "Alphabet cyrillique",
        "Lecture et prononciation",
        "Se saluer et se présenter",
        "Qui est-ce... Qu'est-ce que c'est...",
        "Désigner des objets et des personnes",
        "Ma famille",
        "Le pluriel",
        "L'adjectif",
        "Introduction des cas",
        "Locatif, propositions B et HA",
        "Verbes - 1er groupe",
        "Texte - activités à la maison",
        "Verbes - 2ème groupe",
        "Nationalités",
        "L'accusatif",
        "Verbes de position et couleurs",
        "Chiffres et nombres",
        "Adresse",
        "Verbes - 3ème groupe",
        "Verbes de mouvement - aller",
        "Le génitif",
        "Le datif",
        "L'instrumental",
      ],
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles.",
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    //**************Soft Skills ********************* */

    {
      title: "Soft Skills - Gestion du Stress - Initiation",
      objectives: [
        "Comprendre les principaux concepts liés au stress",
        "Identifier les situations sources de stress dans la vie quotidienne",
        "Acquérir des techniques de gestion du stress",
        "Appliquer les stratégies mentales pour faire face aux situations stressantes",
      ],
      content: [
        "Aperçu du cours",
        "Définir le stress et son influence sur nous",
        "Situations pouvant être à l'origine du stress",
        "Établir des fondations solides",
        "Stratégies mentales",
        "Le stress au travail",
        "Conseils sur la gestion du temps",
        "Le stress à la maison",
        "Ceux qui vous épuisent, ceux qui vous motivent",
      ],
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Soft Skills - Utiliser sa Voix pour Convaincre - Initiation",
      objectives: [
        "Comprendre les aspects physiologiques de la voix",
        "Apprendre à utiliser la voix comme un outil de persuasion",
        "Explorer la dimension corporelle de l'expression vocale",
      ],
      content: [
        "Quelques éléments physiologiques",
        "Un outil majeur pour convaincre",
        "Une dimension corporelle",
        "Comment travailler ma voix",
      ],
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Soft Skills - Les Secrets du Body Language - Initiation",
      objectives: [
        "Comprendre les signaux du langage corporel",
        "Appliquer des exercices pratiques pour améliorer sa présence",
        "Évaluer l'impact de la posture sur la communication",
        "Reconnaître l'importance de l'apparence, notamment la poignée de main",
      ],
      content: [
        "Langage corporel",
        "Donnez moi de l’espace",
        "Que dit votre visage ?",
        "Que dit votre corps ?",
        "Exercice préliminaire",
        "Établir un rapport",
        "Surveiller votre posture",
        "Bien s’habiller",
        "La poignée de main",
        "Résumé",
      ],
      duration: "Soft Skills - Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Soft Skills - Maîtriser votre Communication - Initiation",
      objectives: [
        "Apprenez à établir des relations constructives",
        "Développez une compréhension approfondie de vous-même",
        "Acquérez des compétences clés telles que la communication active et la lecture du langage corporel",
        "Maîtrisez divers styles de communication pour réussir dans toutes les interactions",
      ],
      content: [
        "Créer des relations positives",
        "Accroître notre conscience de soi",
        "Obstacles à la communication",
        "Poser des questions",
        "Capacité d’écoute",
        "Langage corporel",
        "Styles de communication",
        "Créer une image positive de soi",
        "Cadre de référence",
        "Techniques pour le lieu de travail",
        "Affirmation de soi",
      ],
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Soft Skills - Se Présenter en 10 Min - Initiation",
      objectives: [
        "Maîtriser le choix optimal de plateforme",
        "Affiner les compétences rédactionnelles pour des présentations percutantes",
        "Renforcer l'impact et l’adhésion lors de la présentation",
      ],
      content: [
        "Trouver les terrains d’entente",
        "Choisir la bonne plateforme",
        "Sélectionner les grandes lignes et pierres angulaires",
        "Rédiger votre présentation",
        "Peaufiner votre présentation",
        "Adopter un plan pour réussir",
        "Résumé du cours",
      ],
      duration: "Durée a determiner selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Soft Skills - Construire son Personal Branding - Initiation",
      objectives: [
        "Comprendre l'importance de la marque personnelle",
        "Développer un personal branding externe et interne",
        "Fixer des objectifs pour renforcer sa marque personnelle",
        "Maîtriser les stratégies de communication pour le personal branding",
      ],
      content: [
        "Aperçu du cours",
        "Regarder à l'extérieur",
        "Regarder de l'intérieur",
        "Fixer des objectifs",
        "Un réseau pour réussir",
        "Stratégies de communication",
        "Construire votre crédibilité",
        "Votre marque",
        "Gérer votre présence sur les réseaux sociaux",
        "Faire face aux personnes difficiles",
        "Avoir de l'influence",
        "Présentations et réunions",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Soft Skills - Maîtriser la Pensée Critique - Initiation",
      objectives: [
        "Maîtriser les fondements de la pensée critique",
        "Identifier les différentes formes de pensée et leur interaction",
        "Éviter les pièges courants dans la prise de décisions raisonnées",
        "Développer les compétences nécessaires pour un esprit critique",
      ],
      content: [
        "Aperçu du cours",
        "Comprendre la pensée critique",
        "Où s'insèrent les autres types de pensée",
        "Pièges dans la prise de décisions raisonnées",
        "Le processus de pensée critique",
        "Ensemble de compétences d'un penseur critique",
        "Créer des explications",
        "Systèmes de pensée critique et créative",
      ],
      duration: "40 min environ",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Soft Skills - Découvrir la PNL - Initiation",
      objectives: [
        "Comprendre les concepts fondamentaux de la PNL",
        "Maîtriser les présupposés de la PNL pour une approche positive",
        "Appliquer les principes des sens selon la PNL dans la communication",
        "Utiliser un langage enrichi et précis pour renforcer l'impact de la communication",
      ],
      content: [
        "Aperçu du cours",
        "Qu'est-ce que la PNL",
        "Les présupposés de la PNL",
        "Les sens selon la PNL",
        "Utiliser un langage enrichi",
        "Interprétez le langage corporel",
        "Poser des questions claires",
        "Le pouvoir du langage hypnotique",
        "Les outils de la PNL",
        "Établir un rapport",
        "Se mettre en phase avec soi-même",
        "Créer des résultats globaux",
        "Créer un état souhaité",
      ],
      duration: "40 min environ",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Soft Skills - Réussir vos présentations pour convaincre",
      objectives: [
        "Maîtriser les bases de la communication verbale et non verbale",
        "Développer une voix et un discours positifs",
        "Favoriser l'entente et l'optimisation des réunions",
        "Surmonter la nervosité et améliorer les compétences en écriture",
      ],
      content: [
        "Découvrez la communication",
        "Contrôlez votre voix",
        "Adopter le discours positif",
        "Favoriser l’entente",
        "Optimiser les réunions",
        "Maîtriser le langage corporel",
        "Je peux simplement envoyer un mail",
        "Surmonter sa nervosité",
        "Commencer à écrire",
        "Adopter une voix de discours",
        "Ajoutez du punch à votre présentation",
      ],
      duration: "1h environ",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Soft Skills - Réussir votre présentation virtuelle",
      objectives: [
        "Comprendre l'importance des présentations virtuelles",
        "Reconnaître les différences et les défis spécifiques des présentations virtuelles",
        "Acquérir des compétences efficaces de présentation virtuelle",
        "Maîtriser les outils collaboratifs pour des présentations virtuelles réussies",
      ],
      content: [
        "Pourquoi des présentations et des réunions virtuelles",
        "En quoi les présentations virtuelles sont-elles différentes",
        "Défis de la présentation virtuelle",
        "Le présentateur",
        "La présentation",
        "La technologie",
        "Les outils - Zoom",
        "Les outils - Microsoft Teams",
        "Les outils - Gotomeeting",
        "Les outils - Google Meet",
        "Résumé du cours",
      ],
      duration: "40 min environ",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Soft Skills - Parler en public – Gérer la pression",
      objectives: [
        "Planifier et structurer efficacement une présentation",
        "Analyser les champs de force pour une communication pertinente",
        "Maîtriser la nervosité et capter l'attention de l'auditoire",
        "Utiliser un langage corporel efficace pour renforcer le message",
      ],
      content: [
        "Pour commencer",
        "Planification",
        "Analyse des champs de force",
        "Comprendre votre auditoire",
        "Maîtriser sa nervosité",
        "Pour que votre auditoire vous écoute",
        "Thèmes clés",
        "Idées structurantes",
        "Méthodes d’organisation",
        "Notre langage corporel",
        "Début et fin",
        "Élargir un plan de base",
      ],
      duration: "1h environ",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Soft Skills - Gestion du stress",
      objectives: [
        "Comprendre les principaux concepts liés au stress",
        "Identifier les situations sources de stress dans la vie quotidienne",
        "Acquérir des techniques de gestion du stress",
        "Appliquer les stratégies mentales pour faire face aux situations stressantes",
      ],
      content: [
        "Aperçu du cours",
        "Définir le stress et son influence sur nous",
        "Situations pouvant être à l'origine du stress",
        "Etablir des fondations solides",
        "Stratégies mentales",
        "Le stress au travail",
        "Conseils sur la gestion du temps",
        "Le stress à la maison",
        "Ceux qui vous épuisent, ceux qui vous motivent",
      ],
      duration: "30 min environ",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Soft Skills - L’Écoute active",
      objectives: [
        "Maîtriser les principes de l'écoute active",
        "Comprendre les bases du langage corporel",
        "Reconnaître l'importance de l'attitude dans la communication",
        "Encourager la conversation pour établir des relations positives",
      ],
      content: [
        "Définir l’écoute active",
        "Notions de base du langage corporel",
        "L’attitude est tout",
        "Encourager la conversation",
        "Établir des relations",
        "Résumé",
      ],
      duration: "30 min environ",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Soft Skills - Conquérir tous les publics",
      objectives: [
        "Acquérir une compréhension approfondie de la communication interpersonnelle",
        "Maîtriser les techniques d'écoute active pour renforcer les relations",
        "Appliquer les principes du langage corporel pour communiquer efficacement",
        "Faciliter des conversations constructives dans divers contextes professionnels",
      ],
      content: [
        "Bonne compétences en communication",
        "Habiletés interpersonnelles",
        "Se familiariser avec la conversation",
        "Repenser à vos forces",
        "Professionnalisme",
        "Maximiser les réunions",
        "Maîtriser sa nervosité",
        "Résumé",
      ],
      duration: "40 min environ",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Soft Skills - Réussir son entretien",
      objectives: [
        "Acquérir les compétences nécessaires pour préparer efficacement un entretien",
        "Maîtriser l'art de se présenter de manière concise en cinq minutes",
        "Adapter ses compétences pour les entretiens en distanciel et en présentiel",
        "Développer des stratégies pour travailler son image et gérer le stress",
      ],
      content: [
        "Préparer son entretien",
        "Se présenter en 5 min",
        "Distanciel ou présentiel",
        "Travailler son image",
        "Gérer son stress",
        "Prendre confiance en soi",
      ],
      duration: "1h10 environ",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Evaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Soft Skills - Maîtriser les relations publiques",
      objectives: [
        "Comprendre les bases des relations publiques et leur impact sur l'image",
        "Acquérir la compétence pour élaborer des plans de relations publiques efficaces",
        "Maîtriser la structuration de messages et les interactions avec les médias",
        "Gérer les relations publiques et exploiter les réseaux sociaux en situation de crise",
      ],
      content: [
        "Aperçu du cours",
        "Les relations publiques",
        "Élaborer votre plan de relations publiques",
        "Structurer vos messages",
        "Établir des lignes directrices pour les médias",
        "Gestion des médias",
        "Le communiqué de presse",
        "Les relations publiques et la crise",
        "Réseaux sociaux et relations publiques",
      ],
      duration: "40min environ",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Soft Skills - Intelligence émotionnelle",
      objectives: [
        "Définir clairement l'intelligence émotionnelle",
        "Approfondir la compréhension de l'optimisme dans ce contexte",
        "Acquérir des compétences pour reconnaître et comprendre les émotions",
        "Travailler sur sa vision personnelle et son impact sur l'intelligence émotionnelle",
      ],
      content: [
        "Histoire de l’intelligence émotionnelle",
        "Définition de l’intelligence émotionnelle",
        "Optimisme",
        "Comprendre les émotions",
        "Définir votre vision personnelle",
      ],
      duration: "30min environ",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    // ****************************** Compabilité et Finance ******************************
    {
      title: "COMPTABILITÉ - Initiation",
      objectives: [
        "Comprendre et analyser un bilan comptable",
        "Savoir passer une écriture et déterminer un résultat comptable",
        "Réaliser un inventaire comptable et mettre à jour les comptes de stocks",
        "Comprendre et appliquer les mécanismes de la TVA",
        "Analyser des SIG et déterminer le BFR",
      ],
      content: [
        "Faisons le bilan",
        "La partie double",
        "Le résultat",
        "Comptes de bilan et comptes de gestion",
        "Le système comptable",
        "L’inventaire",
        "Les stocks et leur variation",
        "La TVA",
        "Les documents de synthèse",
        "Les SIG",
        "La banque de France",
        "La capacité d’autofinancement",
        "L’analyse du Bilan",
        "Le BFR",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "COMPTABILITÉ - Les Fondamentaux",
      objectives: [
        "Comprendre et analyser un bilan comptable",
        "Savoir passer une écriture et déterminer un résultat comptable",
        "Réaliser un inventaire comptable et mettre à jour les comptes de stocks",
        "Comprendre et appliquer les mécanismes de la TVA",
        "Analyser des SIG et déterminer le BFR",
      ],
      content: [
        "Introduction aux fondements de la comptabilité",
        "Définition et rôle de la comptabilité",
        "La comptabilité et son droit",
        "Analyse et saisie des flux",
        "L'organisation comptable",
        "Les opérations d'achat et de vente",
        "Les écritures de banque",
        "Le suivi des comptes",
        "Exercices",
        "Les écritures de personnel",
        "Acquisition d’immobilisations",
        "Les valeurs mobilières",
        "Les emprunts et les prêts",
        "Les mouvements de capitaux, des réserves, du report à nouveau",
        "Les écritures de fin d’exercice",
        "Construction du Bilan et du compte de Résultat",
        "L’imposition des revenus des entreprises",
        "La TVA",
        "Les autres impôts et taxes",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "COMPTABILITÉ - UE1 - Gestion de Paie",
      objectives: [
        "Comprendre les métiers associés à la gestion de la paie",
        "Maîtriser les sources clés du droit du travail",
        "Apprendre les pratiques de veille en paie",
        "Acquérir une compréhension complète des formalités d'embauche",
      ],
      content: [
        "Les métiers liés à la paie",
        "Les sources du droit du travail",
        "La veille en paie",
        "Créer son profil LinkedIn",
        "Les formalités d'embauche",
        "Le CDI",
        "Le CDD",
        "Les contrats spécifiques des alternants",
        "L'intérim",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "COMPTABILITÉ - UE2 - Calculer le Bulletin de Paie",
      objectives: [
        "Collecter les informations nécessaires pour les bulletins de salaire",
        "Assurer les tâches administratives, comptables et la gestion sociale du personnel",
        "Organiser la formation, la représentation des salariés et les réunions avec les partenaires sociaux",
        "Gérer les déclarations et les relations avec les organismes sociaux, dont l'URSSAF",
        "Maîtriser le logiciel EBP et d'autres outils informatiques dédiés à la paie",
      ],
      content: [
        "Identifier les zones du bulletin de paie",
        "Présentation des 2 bulletins de paie",
        "Partie haut de BP, partie identification",
        "Partie haut de BP, partie salaire",
        "Partie cotisations, les cotisations sociales",
        "Partie cotisations, les bases des cotisations sociales",
        "Allègement de charges sociales",
        "Partie bas de BP - calculer le net imposable",
        "Partie bas de BP - calculer le net à payer",
        "Calculer que le SMIC soit respecté",
        "Calculer la régularisation du PMSS",
        "Les cotisations URSSAF",
        "Les cotisations IRC",
        "Prévoyance & prévoyance frais de santé",
        "Allègements de charges : la réduction générale des cotisations patronales",
        "Allègements de charges : les réductions de charges patronales sur les heures supplémentaires",
        "Allègements de charges : les réductions de charges salariales sur les heures supplémentaires et complémentaires",
        "Calculer un bulletin de paie clarifié",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "COMPTABILITÉ - UE3 - Le Prélèvement à la Source",
      objectives: [
        "Comprendre la réforme du Prélèvement à la Source (PAS) et ses motivations",
        "Déterminer l'obligation de déclaration d'impôt sur le revenu (IR)",
        "Explorer le rôle du Compte Individualisé (CI) dans le PAS",
        "Maîtriser les calculs du PAS, incluant l'assiette et les taux",
        "Accéder aux ressources clés, dont le BOFIP taux non personnalisé, pour le PAS",
      ],
      content: [
        "Pourquoi la réforme du PAS",
        "Dois-je faire la déclaration IR",
        "Focus sur le CI",
        "Le PAS sur le bulletin de paie clarifié depuis 2019",
        "Calcul de l'assiette du PAS",
        "Taux du PAS",
        "Ressources pour le PAS",
        "BOFIP taux non personnalisé",
        "L'assiette du PAS avec des IJSS subrogées",
        "Le PAS et les contrats courts",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title:
        "COMPTABILITÉ - UE4 - Identifier les aménagements du temps de travail",
      objectives: [
        "Comprendre la mensualisation et son rôle dans la gestion du temps de travail",
        "Maîtriser la durée légale du temps de travail",
        "Apprendre les règles du travail à temps partiel",
        "Explorer les aspects du travail de nuit, de soirée, et du temps de travail effectif",
        "Connaître les conventions de forfait pour une gestion efficace du temps de travail",
      ],
      content: [
        "La mensualisation",
        "La durée légale du temps de travail",
        "Le décalage du recueil des éléments variables (EV)",
        "Le temps partiel",
        "L'avenant de complément d'heures",
        "Le maintien des cotisations vieillesse à temps partiel",
        "Le travail de nuit",
        "Le travail de soirée",
        "Le temps de travail effectif",
        "Absence et temps de travail effectif (TTE)",
        "Aménagement du temps de travail",
        "Les heures supplémentaires",
        "La modulation du temps de travail",
        "La convention de forfait annuelle en jours",
        "La convention de forfait en heures sur 1 semaine ou 1 mois",
        "La convention de forfait annuelle en heures",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title:
        "COMPTABILITÉ - UE5 - Identifier le rôle des IRP et la notion de confidentialité",
      objectives: [
        "Comprendre la CPRI, son rôle et sa composition",
        "Apprendre les mandats et le fonctionnement de la CPRI",
        "Explorer le monde syndical et le rôle du délégué syndical",
        "Connaître le CSE et les droits des salariés protégés",
        "Maîtriser les aspects juridiques du licenciement des salariés protégés, le droit de grève, les conflits collectifs, l'inspection du travail, les contentieux du travail, et le RGPD",
      ],
      content: [
        "La CPRI rôle et composition",
        "La CPRI mandat fonctionnement",
        "Le monde syndical",
        "Le délégué syndical",
        "Le CSE",
        "Le salarié protégé",
        "La procédure de licenciement des salariés protégés",
        "Le droit de grève",
        "Les conséquences de la grève",
        "Le règlement des conflits collectifs",
        "L'inspection du travail",
        "Les contentieux du travail : Le conseil de Prud'hommes",
        "Les autres juridictions",
        "Le RGPD",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title:
        "COMPTABILITÉ - UE6 - Calculer un bulletin de paie avec les éléments variables",
      objectives: [
        "Maîtriser tous les aspects de la gestion des ressources humaines, des heures supplémentaires aux congés, en passant par les arrêts maladie et les avantages en nature",
      ],
      content: [
        "Les HS & HC Niveau 1",
        "Les HS & HC Niveau 2",
        "Les absences niveau 1",
        "Les absences niveau 2",
        "Les TR niveau 1",
        "Les CP niveau 1",
        "Les CP niveau 2",
        "Les autres congés",
        "Les arrêts liés à la maladie non professionnelle niv 1",
        "Les arrêts liés aux AT et maladie professionnelle niv 1",
        "Les arrêts liés à la maternité et paternité niv 1",
        "Les jours fériés",
        "Les arrêts liés à la maladie non professionnelle niv 2",
        "Les arrêts liés aux AT et maladie professionnelle niv 2",
        "Les arrêts liés à la maternité et paternité niv 2",
        "Les acomptes",
        "Les avantages en nature niveau 1",
        "Les avantages en nature niveau 2",
        "Les frais professionnels niveau 1",
        "Les frais professionnels niveau 2",
        "Les saisies arrêts et pensions alimentaires",
        "Les avances",
        "La prime pour le pouvoir d'achat dite PEPA",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "COMPTABILITÉ - UE7 - Calculer une paie “particulière”",
      objectives: [
        "Comprendre les règles de gratification des stagiaires",
        "Maîtriser les contrats de professionnalisation et d'apprentissage",
        "Gérer efficacement la paie des mandataires et le cumul avec un salarié",
        "Explorer les spécificités des VRP et de la déduction forfaitaire spécifique",
      ],
      content: [
        "Les HS & HC Niveau 1",
        "Les HS & HC Niveau 2",
        "Les absences niveau 1",
        "Les absences niveau 2",
        "Les TR niveau 1",
        "Les CP niveau 1",
        "Les CP niveau 2",
        "Les autres congés",
        "Les arrêts liés à la maladie non professionnelle niv 1",
        "Les arrêts liés aux AT et maladie professionnelle niv 1",
        "Les arrêts liés à la maternité et paternité niv 1",
        "Les jours fériés",
        "Les arrêts liés à la maladie non professionnelle niv 2",
        "Les arrêts liés aux AT et maladie professionnelle niv 2",
        "Les arrêts liés à la maternité et paternité niv 2",
        "Les acomptes",
        "Les avantages en nature niveau 1",
        "Les avantages en nature niveau 2",
        "Les frais professionnels niveau 1",
        "Les frais professionnels niveau 2",
        "Les saisies arrêts et pensions alimentaires",
        "Les avances",
        "La prime pour le pouvoir d'achat dite PEPA",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "COMPTABILITÉ - UE8 - Calculer la paie de départ",
      objectives: [
        "Comprendre les évolutions et modifications du contrat de travail",
        "Connaître les différents types de procédures liées aux contrats de travail",
        "Maîtriser le calcul de l'indemnité compensatrice de congés payés",
        "Apprendre à calculer et verser les indemnités",
        "Explorer les formalités associées au départ d'un salarié",
      ],
      content: [
        "Évolution ou modification du contrat de travail",
        "Les différents types de procédure",
        "L'indemnité compensatrice de congés payés",
        "L'indemnité de préavis",
        "L'indemnité de fin de contrat",
        "L'indemnité de licenciement",
        "L'indemnité de rupture conventionnelle",
        "L'indemnité de départ à la retraite",
        "L'indemnité de mise à la retraite",
        "Formalités liées au départ du salarié",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "COMPTABILITÉ - UE9 - Calculer les éléments post paie",
      objectives: [
        "Comprendre la DSN et le contrôle des charges sociales",
        "Explorer la retraite supplémentaire et ses implications",
        "Connaître les taxes parafiscales et leur impact sur la paie",
        "Maîtriser l'épargne salariale et son rôle dans la rémunération",
        "Apprendre à comptabiliser la paie et générer des reportings sociaux",
      ],
      content: [
        "DSN et contrôle des charges URSSAF",
        "La retraite supplémentaire",
        "Les taxes parafiscales",
        "L'épargne salariale",
        "Comptabilisation de la paie",
        "Les reportings sociaux",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title:
        "COMPTABILITÉ - UE10 - Simulation d'un oral blanc pour le titre de gestionnaire de paie",
      objectives: [
        "Préparer à l'oral blanc du titre professionnel de gestionnaire de paie",
        "Améliorer les compétences de présentation",
        "Renforcer la capacité à répondre efficacement aux questions lors de l'examen",
      ],
      content: [
        "Simulation d'un oral blanc pour le titre professionnel de gestionnaire de paie",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles",
      materials: [
        "Disposer d'un ordinateur ou d’une tablette",
        "Une connexion Internet",
      ],
      evaluation: [
        "Auto-évaluation sous forme de questionnaires",
        "Exercices sous formes d’ateliers pratiques",
        "Questionnaire de positionnement & Évaluation à chaud",
      ],
      methods: [
        "Accès au cours en ligne",
        "Cours théorique au format vidéo",
        "Accessible via un ordinateur ou une tablette",
        "Assistance par téléphone et/ou email",
      ],
      trainer:
        "Disposant de plusieurs années d’expérience dans l’enseignement de cette discipline",
    },
    {
      title: "Hygiène Alimentaire et Gestion des Allergènes",
      objectives: [
        "Connaître les principaux allergènes alimentaires",
        "Mettre en place une démarche de prévention du risque allergène",
        "Respecter la réglementation sur l’étiquetage et la traçabilité",
      ],
      content: [
        "Les 14 allergènes majeurs selon la réglementation européenne",
        "Risques de contamination croisée",
        "Bonnes pratiques d’hygiène et de fabrication",
        "Communication et information du consommateur",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formation à distance avec supports accessibles. Pas d’audiodescription ni de sous-titrage",
      materials: [
        "Ordinateur ou tablette avec connexion Internet",
        "Supports fournis en PDF",
      ],
      evaluation: [
        "Cas pratiques de détection des allergènes",
        "Quiz de validation des connaissances",
        "Évaluation à chaud",
      ],
      methods: [
        "Supports interactifs",
        "Exemples concrets et vidéos",
        "Accompagnement à distance",
      ],
      trainer:
        "Formateur spécialisé en hygiène alimentaire et réglementation allergènes",
    },
    {
      title: "Hygiène et sécurité alimentaire - Méthode HACCP",
      objectives: [
        "Comprendre les bases de la sécurité alimentaire",
        "Appliquer la méthode HACCP dans un contexte professionnel",
        "Identifier les dangers et maîtriser les points critiques (CCP)",
      ],
      content: [
        "Principes de base de l’hygiène alimentaire",
        "Présentation des 7 principes de la méthode HACCP",
        "Mise en œuvre des procédures de contrôle",
        "Réglementation en vigueur et obligations légales",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formation disponible à distance. Accessible aux personnes à mobilité réduite. Pas de sous-titrage ou audiodescription disponibles",
      materials: [
        "Ordinateur ou tablette",
        "Connexion Internet",
        "Support de formation fourni",
      ],
      evaluation: [
        "Quiz en ligne",
        "Études de cas pratiques",
        "Évaluation des acquis en fin de formation",
      ],
      methods: [
        "Apports théoriques en vidéo",
        "Exercices pratiques et QCM",
        "Assistance pédagogique à distance",
      ],
      trainer:
        "Professionnel de l’agroalimentaire formé à la méthode HACCP et à la réglementation sanitaire",
    },
    {
      title: "Intelligence Artificielle (IA)",
      objectives: [
        "Comprendre les concepts de base de l’intelligence artificielle",
        "Découvrir les principales applications de l’IA dans divers secteurs",
        "Acquérir les notions essentielles en machine learning et deep learning",
      ],
      content: [
        "Définitions et historique de l’IA",
        "Domaines d'application de l’IA",
        "Principes de base du machine learning",
        "Initiation aux réseaux neuronaux",
        "Cas pratiques et études de cas",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Connaissances de base en informatique recommandées",
      accessibility:
        "Formation en ligne accessible aux personnes à mobilité réduite. Audiodescription et sous-titrage disponibles partiellement",
      materials: [
        "Ordinateur avec navigateur à jour",
        "Connexion Internet stable",
      ],
      evaluation: [
        "Quiz de compréhension à chaque module",
        "Mini-projets ou études de cas",
        "Évaluation finale en ligne",
      ],
      methods: [
        "Modules interactifs accessibles à distance",
        "Vidéos explicatives et fiches de synthèse",
        "Forum d’échange avec le formateur",
      ],
      trainer:
        "Expert en intelligence artificielle avec expérience en enseignement et projets concrets",
    },
    {
      title: "Sauveteur Secouriste du Travail (SST)",
      objectives: [
        "Acquérir les gestes de premiers secours en milieu professionnel",
        "Être capable d’intervenir efficacement face à une situation d’accident",
        "Prévenir les risques professionnels dans son environnement de travail",
      ],
      content: [
        "Identification des risques professionnels",
        "Conduite à tenir en cas d’accident du travail",
        "Gestes de premiers secours (saignement, malaise, étouffement, etc.)",
        "Mise en situation pratique avec cas concrets",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en présentiel ou distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles",
      materials: [
        "Disposer d’un espace calme pour les exercices pratiques",
        "Ordinateur ou tablette (en cas de distanciel)",
        "Connexion Internet (en cas de distanciel)",
      ],
      evaluation: [
        "Mises en situation pratiques",
        "Grille d’observation selon les critères de l’INRS",
        "Évaluation à chaud",
      ],
      methods: [
        "Cours en présentiel ou visioconférence",
        "Support vidéo et démonstrations pratiques",
        "Travaux pratiques et interactions avec le formateur",
      ],
      trainer:
        "Formateur certifié SST avec expérience en prévention des risques professionnels",
    },
    {
      title: "Management - RH",
      objectives: [
        "Comprendre les fondamentaux du management d’équipe",
        "Acquérir les compétences clés en gestion des ressources humaines",
        "Savoir conduire un entretien, recruter et évaluer les performances",
      ],
      content: [
        "Principes du management et styles de leadership",
        "Recrutement, intégration et gestion des talents",
        "Entretien professionnel et évaluation des performances",
        "Gestion des conflits et communication interne",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formation disponible en distanciel, accessible aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles",
      materials: ["Ordinateur ou tablette", "Connexion Internet"],
      evaluation: [
        "Études de cas",
        "Mises en situation managériales",
        "Quiz de validation des acquis",
      ],
      methods: [
        "Apports théoriques interactifs",
        "Travaux pratiques et jeux de rôle",
        "Support vidéo et assistance pédagogique",
      ],
      trainer:
        "Consultant-formateur en management et RH avec expérience terrain",
    },
    {
      title: "Infographie",
      objectives: [
        "Découvrir les bases de la création graphique numérique",
        "Maîtriser les outils fondamentaux comme Photoshop, Illustrator ou Canva",
        "Créer des visuels adaptés à la communication professionnelle",
      ],
      content: [
        "Principes de base du design graphique",
        "Typographie, couleurs, composition",
        "Utilisation d’outils graphiques (Adobe ou alternatifs)",
        "Réalisation de supports de communication (affiches, bannières, etc.)",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Connaissances de base en informatique recommandées",
      accessibility:
        "Formation en ligne, accessible aux personnes à mobilité réduite. Pas de sous-titrage ou audiodescription",
      materials: [
        "Ordinateur avec logiciels installés ou accès à Canva",
        "Connexion Internet",
      ],
      evaluation: [
        "Projets graphiques notés",
        "Auto-évaluation guidée",
        "Évaluation par le formateur",
      ],
      methods: [
        "Tutoriels vidéo pas à pas",
        "Exercices pratiques sur projet",
        "Correction individualisée",
      ],
      trainer:
        "Graphiste professionnel avec expérience en formation et outils numériques",
    },
    {
      title: "Productivité de l’Entreprise",
      objectives: [
        "Identifier les leviers de performance au sein de l’entreprise",
        "Mettre en place des outils et méthodes d’optimisation",
        "Améliorer l’organisation du travail et la gestion du temps",
      ],
      content: [
        "Diagnostic de la productivité",
        "Méthodes Lean, Kaizen, 5S",
        "Gestion du temps et priorisation",
        "Outils numériques d’optimisation des processus",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formation en distanciel accessible aux personnes à mobilité réduite. Audiodescription non disponible",
      materials: ["Ordinateur ou tablette", "Connexion Internet"],
      evaluation: [
        "Études de cas en entreprise",
        "Quiz d’évaluation des acquis",
        "Plan d'action individuel à la fin de la formation",
      ],
      methods: [
        "Cours en ligne et webinaires",
        "Outils de simulation",
        "Accompagnement individuel ou collectif",
      ],
      trainer:
        "Consultant en organisation et performance avec expérience en PME et grands groupes",
    },
    {
      title: "Reconversion Professionnelle – Coaching & Accompagnement - ",
      objectives: [
        "Faire le point sur son parcours et ses compétences",
        "Explorer les pistes de reconversion adaptées à son profil",
        "Élaborer un projet professionnel réaliste et motivant",
      ],
      content: [
        "Bilan de compétences simplifié",
        "Exploration des secteurs et métiers porteurs",
        "Rédaction d’un plan de reconversion",
        "Techniques de recherche d’emploi et de candidature",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formation en ligne accessible aux personnes à mobilité réduite. Audiodescription non disponible",
      materials: ["Ordinateur ou tablette", "Connexion Internet"],
      evaluation: [
        "Plan de projet personnalisé",
        "Feedback individuel du formateur",
        "Auto-évaluation et journal de progression",
      ],
      methods: [
        "Ateliers interactifs",
        "Coaching individuel",
        "Accès à des ressources métiers et fiches pratiques",
      ],
      trainer:
        "Coach en évolution professionnelle certifié, spécialisé en reconversion",
    },
    {
      title: "CAO - DAO",
      objectives: [
        "Comprendre les bases de la conception assistée par ordinateur",
        "S’initier à l’utilisation de logiciels de CAO/DAO comme AutoCAD ou SketchUp",
        "Réaliser des dessins techniques et des plans en 2D et 3D",
      ],
      content: [
        "Notions fondamentales de CAO/DAO",
        "Prise en main d’un logiciel de dessin (AutoCAD, SketchUp, etc.)",
        "Création de dessins 2D",
        "Introduction au dessin 3D",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aisance avec l’outil informatique recommandée",
      accessibility:
        "Formation à distance, accessible aux personnes à mobilité réduite. Pas de sous-titrage ni audiodescription",
      materials: [
        "Ordinateur avec logiciel CAO/DAO installé",
        "Connexion Internet",
      ],
      evaluation: [
        "Réalisation de plans techniques",
        "Mini-projets pratiques",
        "Évaluation finale des acquis",
      ],
      methods: [
        "Tutoriels vidéo",
        "Exercices guidés",
        "Correction et accompagnement personnalisés",
      ],
      trainer:
        "Dessinateur-projeteur ou ingénieur avec expérience en CAO/DAO et pédagogie",
    },
    {
      title: "Développement Web",
      objectives: [
        "Acquérir les compétences fondamentales en développement web",
        "Maîtriser HTML, CSS, JavaScript et les bases de React ou Vue",
        "Savoir créer un site web responsive et interactif",
      ],
      content: [
        "Introduction au web : fonctionnement et technologies",
        "Langages de base : HTML, CSS, JavaScript",
        "Utilisation de bibliothèques et frameworks (React, Vue)",
        "Principes de responsive design et accessibilité",
        "Initiation à la gestion de projets web",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Connaissances de base en informatique recommandées",
      accessibility:
        "Formation en ligne accessible aux personnes à mobilité réduite. Audiodescription non disponible",
      materials: ["Ordinateur", "Connexion Internet"],
      evaluation: [
        "Réalisation d’un mini-site ou application",
        "Quiz interactifs à chaque module",
        "Évaluation finale par projet",
      ],
      methods: [
        "Cours en ligne interactifs",
        "Exercices de code pratiques",
        "Support vidéo et forum d’entraide",
      ],
      trainer: "Développeur web expérimenté avec compétences pédagogiques",
    },
    {
      title: "Kinésithérapie",
      objectives: [
        "Comprendre les bases de l’anatomie et de la physiothérapie",
        "Découvrir les techniques fondamentales utilisées en kinésithérapie",
        "Sensibiliser à la posture, au mouvement et à la prévention des troubles musculaires",
      ],
      content: [
        "Anatomie fonctionnelle",
        "Principes de la rééducation motrice",
        "Techniques de base (massage, mobilisation, étirements)",
        "Prévention des troubles musculo-squelettiques (TMS)",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formation accessible aux personnes à mobilité réduite. Audiodescription non disponible",
      materials: ["Ordinateur ou tablette", "Connexion Internet"],
      evaluation: [
        "Études de cas",
        "Quiz sur les connaissances anatomiques",
        "Exercices pratiques supervisés (si applicable)",
      ],
      methods: [
        "Apports théoriques en vidéo",
        "Démonstrations pratiques",
        "Suivi par un formateur",
      ],
      trainer: "Kinésithérapeute diplômé ayant une expérience pédagogique",
    },
    {
      title: "Vente et Marketing Digital",
      objectives: [
        "Maîtriser les techniques de vente moderne en ligne et en boutique",
        "Comprendre les leviers du marketing digital",
        "Savoir utiliser les réseaux sociaux et les outils numériques pour vendre",
      ],
      content: [
        "Processus de vente : de la prospection à la fidélisation",
        "Comportement consommateur et argumentaire commercial",
        "Notions de marketing digital : SEO, SEA, réseaux sociaux",
        "Utilisation des outils numériques (CRM, emailing, analytics)",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formation à distance accessible aux personnes à mobilité réduite. Sous-titrage non disponible",
      materials: ["Ordinateur ou tablette", "Connexion Internet"],
      evaluation: [
        "Jeux de rôle et simulations de vente",
        "Analyse de cas concrets",
        "Quiz et mini-projets marketing",
      ],
      methods: [
        "Cours en ligne interactifs",
        "Exercices pratiques et études de cas",
        "Accompagnement personnalisé",
      ],
      trainer:
        "Formateur en vente et marketing digital, ancien professionnel du secteur",
    },
    {
      title: "Sécurité",
      objectives: [
        "Connaître les règles fondamentales de la sécurité en entreprise",
        "Prévenir les risques professionnels et adopter les bons réflexes",
        "Se préparer à agir en situation d'urgence",
      ],
      content: [
        "Principes généraux de prévention",
        "Identification des risques (incendie, électrique, chimiques...)",
        "Gestes et postures de sécurité",
        "Procédures d’évacuation et consignes en cas d’urgence",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formation accessible aux personnes à mobilité réduite. Audiodescription non disponible",
      materials: ["Ordinateur ou tablette", "Connexion Internet"],
      evaluation: [
        "Mises en situation",
        "Quiz de validation",
        "Évaluation des connaissances pratiques",
      ],
      methods: [
        "Apports théoriques en ligne",
        "Cas pratiques et scénarios",
        "Assistance pédagogique",
      ],
      trainer:
        "Spécialiste de la sécurité en milieu professionnel avec expérience terrain",
    },
    {
      title: "CACES – Certificat d’Aptitude à la Conduite En Sécurité",
      objectives: [
        "Préparer à la conduite en sécurité d’engins de manutention",
        "Respecter la réglementation en vigueur",
        "Valider les compétences pratiques pour l'obtention du CACES",
      ],
      content: [
        "Connaissance des engins (chariots, nacelles, grues...)",
        "Consignes de sécurité et réglementation",
        "Contrôle et maintenance de premier niveau",
        "Pratique de la conduite sur plateau technique",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aptitude médicale à la conduite d'engins",
      accessibility:
        "Formation partiellement accessible – présence physique requise pour la pratique",
      materials: [
        "Équipements de protection individuelle (EPI)",
        "Accès à un poste informatique pour la théorie",
      ],
      evaluation: [
        "Tests théoriques",
        "Épreuves pratiques sur engins",
        "Évaluation selon référentiel CACES en vigueur",
      ],
      methods: [
        "Cours théoriques en ligne ou en salle",
        "Exercices pratiques encadrés",
        "Encadrement par un formateur certifié",
      ],
      trainer:
        "Formateur agréé CACES avec expérience en formation professionnelle",
    },
    {
      title: "Coiffure et Esthétique",
      objectives: [
        "Découvrir les bases de la coiffure et des soins esthétiques",
        "Acquérir les gestes professionnels en hygiène, coupe, soin et maquillage",
        "Comprendre la relation client dans un cadre de bien-être",
      ],
      content: [
        "Hygiène et sécurité dans le secteur de la beauté",
        "Techniques de coiffure de base (shampoing, brushing, coupe)",
        "Soins esthétiques : visage, ongles, maquillage",
        "Conseil client et présentation des produits",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formation accessible aux personnes à mobilité réduite. Audiodescription non disponible",
      materials: [
        "Matériel de coiffure et esthétique (liste fournie au démarrage)",
        "Connexion Internet pour la partie théorique",
      ],
      evaluation: [
        "Mises en situation pratiques",
        "Évaluation continue par le formateur",
        "Fiche d’auto-évaluation des compétences acquises",
      ],
      methods: [
        "Démonstrations en vidéo",
        "Pratique supervisée en atelier (si en présentiel)",
        "Suivi individualisé",
      ],
      trainer:
        "Professionnel(le) de la beauté avec expérience en salon et en formation",
    },
    {
      title: "Hygiène Alimentaire et Gestion des Allergènes",
      objectives: [
        "Comprendre les principes d’hygiène alimentaire selon la réglementation en vigueur",
        "Identifier les allergènes courants et prévenir les risques liés",
        "Mettre en œuvre des bonnes pratiques dans la préparation et la manipulation des aliments",
      ],
      content: [
        "Principes de base de l’hygiène en restauration et agroalimentaire",
        "Sources de contamination et prévention",
        "Identification des 14 allergènes majeurs",
        "Mesures de prévention des risques allergiques",
        "Traçabilité et étiquetage des produits",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis",
      accessibility:
        "Formations en distanciel accessibles aux personnes à mobilité réduite. Audiodescription et sous-titrage non disponibles",
      materials: [
        "Ordinateur ou tablette",
        "Connexion Internet stable",
        "Accès à un espace calme pour suivre la formation",
      ],
      evaluation: [
        "Quiz interactifs de validation des acquis",
        "Études de cas pratiques",
        "Évaluation finale des connaissances",
      ],
      methods: [
        "Modules e-learning avec vidéos explicatives",
        "Supports téléchargeables (PDF, fiches pratiques)",
        "Assistance pédagogique à distance",
      ],
      trainer:
        "Formateur expert en hygiène alimentaire et sécurité sanitaire avec expérience terrain",
    },
    {
      title: "Comptabilité & Paie",
      objectives: [
        "Acquérir les fondamentaux de la comptabilité générale",
        "Maîtriser les logiciels de paie et les déclarations sociales",
        "Être capable de gérer les opérations comptables courantes",
      ],
      content: [
        "Introduction à la comptabilité",
        "Journal, grand livre et bilan",
        "Calcul des salaires et gestion des bulletins de paie",
        "Déclarations sociales (URSSAF, cotisations)",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Notions de base en mathématiques souhaitées",
      accessibility:
        "Formation en ligne accessible aux personnes à mobilité réduite. Support visuel optimisé, sous-titrage vidéo disponible.",
      materials: ["Ordinateur", "Connexion Internet", "Calculatrice"],
      evaluation: [
        "Études de cas pratiques",
        "Exercices de mise en situation",
        "Contrôle des connaissances en ligne",
      ],
      methods: [
        "Cours théoriques interactifs",
        "Travaux pratiques sur logiciels de comptabilité",
        "Supports téléchargeables et vidéos explicatives",
      ],
      trainer:
        "Formateur expert en comptabilité et gestion de la paie avec expérience terrain en cabinet ou entreprise",
    },
    {
      title: "Outils Bureautiques (Excel, Word, PowerPoint)",
      objectives: [
        "Maîtriser les fonctionnalités essentielles des outils bureautiques",
        "Créer des documents professionnels efficaces",
        "Gagner du temps grâce aux fonctions avancées",
      ],
      content: [
        "Initiation et perfectionnement sur Excel (formules, tableaux croisés dynamiques)",
        "Création de documents Word (CV, rapports, mises en page)",
        "Conception de présentations PowerPoint percutantes",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aisance minimale avec l'utilisation d’un ordinateur",
      accessibility:
        "Formation accessible avec raccourcis clavier et zooms adaptés. Supports écrits et vidéos inclus.",
      materials: ["Ordinateur", "Suite Microsoft Office", "Connexion Internet"],
      evaluation: [
        "Exercices pratiques sur chaque outil",
        "Mini-projets de mise en application",
        "Quiz interactifs en fin de module",
      ],
      methods: [
        "Tutoriels guidés pas à pas",
        "Travaux dirigés",
        "Entraînement sur fichiers réels",
      ],
      trainer:
        "Formateur certifié Microsoft Office Specialist, expert en bureautique et productivité numérique",
    },
    {
      title: "Langues Étrangères (Français, Anglais, etc.)",
      objectives: [
        "Développer ses compétences orales et écrites",
        "Améliorer la compréhension et l'expression dans un contexte professionnel ou quotidien",
        "Préparer les certifications linguistiques (TOEIC, DELF, etc.)",
      ],
      content: [
        "Grammaire et vocabulaire adaptés au niveau de l'apprenant",
        "Mises en situation orales et écrites",
        "Compréhension de dialogues et de documents authentiques",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Aucun prérequis — test de positionnement initial proposé",
      accessibility:
        "Supports audio, visuels, et transcriptions disponibles. Adapté aux personnes malentendantes.",
      materials: [
        "Casque audio recommandé",
        "Connexion Internet",
        "Cahier de notes",
      ],
      evaluation: [
        "Tests de niveau réguliers",
        "Production orale et écrite",
        "Feedback personnalisé du formateur",
      ],
      methods: [
        "Cours en visioconférence ou e-learning",
        "Jeux de rôle et mises en situation",
        "Utilisation d’applications linguistiques",
      ],
      trainer:
        "Enseignant natif ou certifié, spécialisé dans l’enseignement des langues étrangères pour adultes",
    },
    {
      title: "Design Graphique",
      objectives: [
        "Maîtriser les bases du design visuel et de la communication graphique",
        "Savoir utiliser les outils de création (Photoshop, Illustrator, etc.)",
        "Créer des supports graphiques professionnels et impactants",
      ],
      content: [
        "Principes fondamentaux du design graphique",
        "Manipulation des logiciels de création (Adobe ou alternatives)",
        "Création de logos, affiches, flyers, contenus pour les réseaux sociaux",
      ],
      duration: "Durée à déterminer selon le besoin.",
      prerequisites: "Connaissances informatiques de base",
      accessibility:
        "Interface utilisateur adaptée, tutoriels visuels et exercices pratiques inclus.",
      materials: [
        "Ordinateur performant",
        "Logiciel de design installé",
        "Connexion Internet",
      ],
      evaluation: [
        "Création de projets graphiques personnalisés",
        "Revue de portfolio par le formateur",
        "Auto-évaluation et progression continue",
      ],
      methods: [
        "Cours en ligne interactifs",
        "Exercices pratiques sur projets réels",
        "Mentorat individuel selon le niveau",
      ],
      trainer:
        "Designer graphique professionnel avec expérience en studio ou freelance, expert Adobe",
    },
  ],
};
export default Languages;
